import HomePage from "../pages/home"

import type { Route } from "./+types/home"


const TITLE = "MesaOTC — Cobrança e liquidação multiativo"
const DESCRIPTION =
  "Infraestrutura de cobrança e liquidação multiativo. Cobre em qualquer moeda e receba na sua — fiat, stablecoin ou cripto — com liquidez própria e operação institucional embutida."
const CANONICAL = "https://mesaotc.com"
const OG_IMAGE = "https://mesaotc.com/og-image.png"

export function meta(_: Route.MetaArgs) {
  return [
    { title: TITLE },
    {
      name: "description",
      content: DESCRIPTION,
    },
    {
      name: "keywords",
      content:
        "cobrança multiativo, liquidação cross-currency, stablecoin, USDT, USDC, fiat, cripto, pix, wire, infraestrutura financeira, API de pagamentos, MesaOTC",
    },
    { name: "author", content: "MesaOTC" },
    { name: "robots", content: "index, follow" },
    { rel: "canonical", href: CANONICAL },

    { property: "og:type", content: "website" },
    { property: "og:locale", content: "pt_BR" },
    { property: "og:site_name", content: "MesaOTC" },
    { property: "og:url", content: CANONICAL },
    { property: "og:title", content: TITLE },
    { property: "og:description", content: DESCRIPTION },
    { property: "og:image", content: OG_IMAGE },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    {
      property: "og:image:alt",
      content:
        "MesaOTC — infraestrutura de cobrança e liquidação multiativo",
    },

    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:site", content: "@mesaotc" },
    { name: "twitter:title", content: TITLE },
    { name: "twitter:description", content: DESCRIPTION },
    { name: "twitter:image", content: OG_IMAGE },
  ]
}

export default HomePage
